export default __webpack_public_path__ + "static/media/Gene_X_Shorter_Length_Control_DNA.0eb207f3.svg";